import { render, staticRenderFns } from "./XsellProduct.vue?vue&type=template&id=cf338378&scoped=true&lang=pug&"
import script from "./XsellProduct.vue?vue&type=script&lang=js&"
export * from "./XsellProduct.vue?vue&type=script&lang=js&"
import style0 from "./XsellProduct.vue?vue&type=style&index=0&id=cf338378&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf338378",
  null
  
)

export default component.exports